import React, { Component } from "react";
import { connect } from 'react-redux';
import * as actionCreators from '../../../modules/actions/index';
import * as url from './../../../utils/url';
import axios from './../../../axios';
import MapGender from './../../../components/OrganizationSetup/MapGender/MapGender';
import EnterpriseBreadcrumb from './../../../components/EnterpriseBreadcrumb/EnterpriseBreadcrumb';

class MapGenderManagement extends Component {
  constructor(props) {
    super(props);
    this.state = {
      existingMapping : null
    }
  }

  componentDidMount() {
    window.scrollTo(0, 0);
    // console.log('this.props', this.props);
    const {organizationId} = this.props.user;
    axios.get(url.getExistingMappings(organizationId._id)).then(({data}) => {
      const payload = data.data;
      const {gender} = payload.mapping;
      this.props.onMatchColumn(gender.columnName);
      const genderData = gender.data;
      let allMapping = []
      genderData.forEach((c) => {
        const mapping = c.values.map((v) => {
          return {
            value : v,
            column : {
              label : v,
              value : c.key
            }
          }
        })
        allMapping = allMapping.concat(mapping);
      })
      this.props.saveAllGenderMapping(allMapping);
    })
  }

  componentWillUnmount() {
    this.props.resetMapGenderStep();
  }

  handleFileUpload = (columns, data, file) => {
    this.props.onFileDataProcessed(columns, data, file);
  }

  handleMatchColumn = (matchedColumn) => {
    this.props.onMatchColumn(matchedColumn);
  }

  render() {
    return (
      <div className="mt60 enterprise-map-page">
        <EnterpriseBreadcrumb 
          linkText="Enterprise Management" 
          link="/home/enterprise-info" 
          activeText="Map Gender"
          {...this.props}
          />
        <MapGender 
          onProcessedFileUploadData={this.handleFileUpload}
          onMapGenderMatchColumn={this.handleMatchColumn}
          isRepeatFlow
          {...this.props}/>
      </div>
    );
  }
}

const mapStateToProps = state => {
  return {
    user: state.user.profile,
    mapGender: state.mapping.gender
  }
}

const mapDispatchToProps = dispatch => {
	return {
    resetMapGenderStep: () => dispatch(actionCreators.resetMapGenderStep()),
    nextStep: () => dispatch(actionCreators.mapGenderNextStep()),
    goBack : () => dispatch(actionCreators.mapGenderGoBack()),
    reset : () => dispatch(actionCreators.resetGender()),
    saveAllGenderMapping : (m) => dispatch(actionCreators.saveAllGenderMapping(m)),
    onFileDataProcessed: (c,d,f) => dispatch(actionCreators.mapGenderUploadFileSuccess(c,d,f)),
    onMatchColumn: data => dispatch(actionCreators.mapGenderMatchColumnSuccess(data))
	}
}

export default connect(mapStateToProps,mapDispatchToProps)(MapGenderManagement);